import { useEffect, useState } from 'react';
import { authenticationService } from '../scripts/authentication.service';

type User = {
  username: string;
  perms: {
    admin: number;
    dev: number;
    c1: number;
    c2: number;
    c3: number
    p1: number;
    p2: number;
    p3: number;
    import: number;
    dupes: number;
  }
}

export function useCurrentUser() {
  const [data, setData] = useState<User | null>(authenticationService.currentUserValue);

  useEffect(() => {
    const subscription = authenticationService.currentUser.subscribe({
      next: (value) => setData(value),
      error: (err) => console.error('Error in currentUser subscription:', err)
    });

    return () => subscription.unsubscribe();
  }, []);

  return data
}
